<template>
  <v-dialog
    v-model="dialog"
    width="450"
  >
    <v-card
      min-height="450"
      :loading="loading"
    >
      <template slot="progress">
        <v-overlay absolute class="d-flex flex-column text-center">
          <v-progress-circular size="75" coleor="accent" indeterminate>
            <span>Loading</span>
          </v-progress-circular>
        </v-overlay>
      </template>
      <template
        v-if="!loading"
      >
        <v-img
          height="250"
          :src="person.picture.image"
        ></v-img>
        <v-card-title>
          {{ fullName }}
        </v-card-title>
        <v-card-subtitle>
          {{ person.document_number }}
        </v-card-subtitle>

        <v-divider class="mx-4"></v-divider>

        <v-card-text>
          <v-row
            class="py-2"
            no-gutters
            v-for="profile in person.profiles" :key="profile.id"
          >
            <v-col cols="12">
              <span class="text-subtitle-1"><i>Zonas:</i></span>
            </v-col>
            <v-col
              v-for="zone in profile.zones"
              :key="zone.id"
              cols="12"
            >
            {{ zone.name }}
            </v-col>
            <v-col cols="6" class="my-2">
              Fecha de vencimiento:
            </v-col>
            <v-col cols="6" class="my-2 text-right">
              <b>{{ profile.expiration_date | date }}</b>
            </v-col>
          </v-row>
          <v-row>
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  Info Controladora
                  <template v-slot:actions>
                    <v-icon>
                      mdi-alert-circle
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <pre>{{ permission }}</pre>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="grey"
            @click="dialog = !dialog"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import types from '@/types';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    personId: {
      type: String,
      default: null,
    },
    controllerId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ...mapState(
      `${types.PERSON}`, [
        'person',
        'persons',
      ],
    ),
    ...mapState(
      `${types.CONTROLLER}`, [
        'permission',
      ],
    ),
    fullName() {
      if (this.person.name === this.person.last_name) {
        return this.person.name;
      }
      return `${this.person.name} ${this.person.last_name}`;
    },
  },

  methods: {
    ...mapActions({
      [types.GET_PERSON]: `${types.PERSON}/${types.GET_PERSON}`,
    }),
    ...mapActions({
      [types.GET_PERSON_PERMISSION]: `${types.CONTROLLER}/${types.GET_PERSON_PERMISSION}`,
    }),
  },

  mounted() {
    this[types.GET_PERSON](this.personId)
      .then(() => {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });

    this[types.GET_PERSON_PERMISSION]({ controllerId: this.controllerId, personId: this.personId });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PersonModal.vue